const menuToggle = document.querySelector(".menu-toggle");
const navShell = document.querySelector(".nav-shell");

if (menuToggle && navShell) {
  menuToggle.addEventListener("click", () => {
    const isOpen = navShell.classList.toggle("open");
    menuToggle.setAttribute("aria-expanded", String(isOpen));
  });
}

document.documentElement.classList.remove("no-js");

if (window.location.pathname.replace(/\/$/, "") === "/pages/env-operations") {
  document.body.classList.add("env-operations-route");
}

document.querySelectorAll("[data-env-fallback]").forEach((fallback) => {
  const mainEnvSections = Array.from(document.querySelectorAll(".env-partner:not([data-env-fallback])"));
  if (mainEnvSections.length > 0) {
    fallback.replaceWith(...mainEnvSections);
  }
});

if (!document.body.classList.contains("env-operations-route")) {
  const mainContent = document.querySelector("#MainContent");
  document.querySelectorAll(".env-partner").forEach((envSection) => {
    mainContent?.appendChild(envSection);
  });
}

document.querySelectorAll("[data-message-widget]").forEach((widget) => {
  const toggle = widget.querySelector("[data-message-widget-toggle]");
  const panel = widget.querySelector("[data-message-widget-panel]");
  const closeButtons = widget.querySelectorAll("[data-message-widget-close]");

  if (!toggle || !panel) return;

  const setOpen = (isOpen) => {
    widget.classList.toggle("open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
    panel.setAttribute("aria-hidden", String(!isOpen));
    if (isOpen) panel.querySelector("input, textarea, button")?.focus();
  };

  toggle.addEventListener("click", () => {
    setOpen(!widget.classList.contains("open"));
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && widget.classList.contains("open")) setOpen(false);
  });

  if (widget.querySelector(".form-status")) setOpen(true);
});

document.querySelectorAll("[data-history-back]").forEach((link) => {
  link.addEventListener("click", (event) => {
    const referrer = document.referrer ? new URL(document.referrer) : null;
    if (referrer && referrer.origin === window.location.origin && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
});

const seededRank = (value) => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash);
};

document.querySelectorAll("[data-daily-featured-grid]").forEach((grid) => {
  const visibleCount = Number(grid.dataset.visibleCount || 6);
  const today = new Date();
  const daySeed = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
  const products = Array.from(grid.querySelectorAll("[data-featured-product]"));

  products
    .sort((first, second) => {
      const firstKey = first.dataset.featuredKey || first.textContent || "";
      const secondKey = second.dataset.featuredKey || second.textContent || "";
      return seededRank(`${daySeed}:${firstKey}`) - seededRank(`${daySeed}:${secondKey}`);
    })
    .forEach((product, index) => {
      product.classList.toggle("featured-hidden", index >= visibleCount);
      grid.appendChild(product);
    });
});

const manualFeaturedHandles = [
  "slp600d",
  "brubr8600",
  "pubr9000",
  "prokut-18-v-battery-pruning-secateurs-kit",
  "prokut-18v-battery-powered-pruning-saw-kit",
  "pw2700-v",
  "rt25zb20-1-2q",
  "north-star-98l-sprayer-12v-nu98l"
];

const availableByOrderFeaturedHandles = new Set(["brubr8600", "pubr9000"]);

const escapeHTML = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const formatMoney = (cents) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD"
  }).format(Number(cents || 0) / 100);

const productImageUrl = (product) => {
  const image = product.featured_image || product.images?.[0] || "";
  if (!image) return "";
  return image.startsWith("//") ? `https:${image}` : image;
};

const manualProductCard = (product) => {
  const firstAvailableVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0] || {};
  const image = productImageUrl(product);
  const compareAtPrice = Number(product.compare_at_price || firstAvailableVariant.compare_at_price || 0);
  const price = Number(product.price || firstAvailableVariant.price || 0);
  const isSale = compareAtPrice > price;
  const isAvailable = Boolean(product.available && firstAvailableVariant.available);
  const isAvailableByOrder = !isAvailable && availableByOrderFeaturedHandles.has(product.handle);

  return `
    <div class="featured-product-shell" data-featured-product data-featured-key="${escapeHTML(product.handle)}">
      <article class="product-card">
        ${isAvailableByOrder ? '<span class="badge order">Available by order</span>' : ""}
        ${!isAvailableByOrder && isSale ? '<span class="badge">Sale</span>' : ""}
        ${!isAvailableByOrder && !isAvailable ? '<span class="badge blue">Sold out</span>' : ""}
        <a class="product-media" href="${escapeHTML(product.url || `/products/${product.handle}`)}">
          ${
            image
              ? `<img src="${escapeHTML(image)}" loading="lazy" alt="${escapeHTML(product.title)}">`
              : `<div class="product-placeholder">${escapeHTML(product.title).slice(0, 3)}</div>`
          }
        </a>
        <div class="product-info">
          ${product.vendor ? `<p>${escapeHTML(product.vendor)}</p>` : ""}
          <h3><a href="${escapeHTML(product.url || `/products/${product.handle}`)}">${escapeHTML(product.title)}</a></h3>
          <div class="price">
            ${formatMoney(price)}
            ${isSale ? `<s>${formatMoney(compareAtPrice)}</s>` : ""}
          </div>
          <form method="post" action="/cart/add" class="quick-add-form" enctype="multipart/form-data">
            <input type="hidden" name="id" value="${escapeHTML(firstAvailableVariant.id || "")}">
            <button type="submit" ${!isAvailable ? "disabled" : ""}>${isAvailable ? "Add to cart" : isAvailableByOrder ? "Call to order" : "Sold out"}</button>
          </form>
        </div>
      </article>
    </div>
  `;
};

document.querySelectorAll(".featured-product-grid").forEach(async (grid) => {
  if (grid.querySelector("[data-featured-product]")) return;

  const products = (
    await Promise.all(
      manualFeaturedHandles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${handle}.js`);
          return response.ok ? response.json() : null;
        } catch {
          return null;
        }
      })
    )
  ).filter(Boolean);

  if (products.length === 0) return;

  grid.querySelector(".featured-empty")?.remove();
  grid.insertAdjacentHTML("beforeend", products.map(manualProductCard).join(""));
});

document.querySelectorAll("[data-hero-media-rotator]").forEach((rotator, rotatorIndex) => {
  let slides = Array.from(rotator.querySelectorAll("[data-hero-media-slide]"));
  const interval = Number(rotator.dataset.interval || 6000);
  let currentIndex = slides.findIndex((slide) => slide.classList.contains("active"));
  let imageTimer = null;

  if (slides.length === 0) return;

  if (rotator.dataset.randomizeMedia === "true" && slides.length > 1) {
    const today = new Date();
    const daySeed = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    const randomSeed = `${daySeed}:${rotator.dataset.randomSeed || window.location.pathname}:${rotatorIndex}`;

    slides
      .sort((first, second) => {
        const firstKey = first.dataset.mediaKey || first.querySelector("source, img")?.getAttribute("src") || "";
        const secondKey = second.dataset.mediaKey || second.querySelector("source, img")?.getAttribute("src") || "";
        return seededRank(`${randomSeed}:${firstKey}`) - seededRank(`${randomSeed}:${secondKey}`);
      })
      .forEach((slide, index) => {
        slide.classList.toggle("active", index === 0);
        rotator.appendChild(slide);
      });

    currentIndex = 0;
  }

  if (currentIndex < 0) currentIndex = 0;

  const scheduleImageAdvance = (slide) => {
    window.clearTimeout(imageTimer);
    if (slides.length <= 1) return;

    const video = slide.querySelector("video");
    if (!video) {
      imageTimer = window.setTimeout(showNextSlide, interval);
    }
  };

  const activateSlide = (nextIndex) => {
    slides.forEach((slide, index) => {
      const video = slide.querySelector("video");
      const isActive = index === nextIndex;
      slide.classList.toggle("active", isActive);

      if (!video) return;
      if (isActive) {
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    scheduleImageAdvance(slides[nextIndex]);
  };

  const showNextSlide = () => {
    currentIndex = (currentIndex + 1) % slides.length;
    activateSlide(currentIndex);
  };

  slides.forEach((slide) => {
    const video = slide.querySelector("video");
    if (!video) return;

    video.addEventListener("ended", showNextSlide);
    video.addEventListener("error", () => {
      if (slide.classList.contains("active")) imageTimer = window.setTimeout(showNextSlide, interval);
    });
  });

  activateSlide(currentIndex);
});

document.querySelectorAll("[data-tamborine-modal]").forEach((modal) => {
  const openButtons = document.querySelectorAll(`[data-tamborine-open][aria-controls="${modal.id}"]`);
  const closeButtons = modal.querySelectorAll("[data-tamborine-close]");

  const close = () => {
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("modal-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));
  };

  const open = () => {
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "true"));
    modal.querySelector("[data-tamborine-close]")?.focus();
  };

  openButtons.forEach((button) => button.addEventListener("click", open));
  closeButtons.forEach((button) => button.addEventListener("click", close));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("open")) close();
  });
});

document.querySelectorAll("[data-service-area-modal]").forEach((modal) => {
  const openButtons = document.querySelectorAll(`[data-service-area-open][aria-controls="${modal.id}"]`);
  const closeButtons = modal.querySelectorAll("[data-service-area-close]");

  const close = () => {
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("modal-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));
  };

  const open = () => {
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-open");
    openButtons.forEach((button) => button.setAttribute("aria-expanded", "true"));
    modal.querySelector("[data-service-area-close]")?.focus();
  };

  openButtons.forEach((button) => button.addEventListener("click", open));
  closeButtons.forEach((button) => button.addEventListener("click", close));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("open")) close();
  });
});
